export default __webpack_public_path__ + "static/media/doctor_avatar.7a7b1455.png";